import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';

/* CSS */
import styles from './PostSavePanel.module.css';
import shared from '../../styles/shared.module.css';

/* Components */
import ShareModal from '../share/ShareModal';

/* Icons */
import share_unclicked from '../../assets/icons/share_unclicked.svg';
import share_clicked from '../../assets/icons/share_clicked.svg';
import cost_breakdown_unclicked from '../../assets/icons/cost_breakdown_unclicked.svg';
import cost_breakdown_clicked from '../../assets/icons/cost_breakdown_clicked.svg';

// import save_to_list_unclicked from '../../assets/icons/save_to_list_unclicked.svg';
// import save_to_list_clicked from '../../assets/icons/save_to_list_clicked.svg';
// import download_unclicked from '../../assets/icons/download_unclicked.svg';
// import download_clicked from '../../assets/icons/download_clicked.svg';

const PostSavePanel = ({ isOpen, tripTitle, tripId, access, onClose, onDone }) => {

    const navigate = useNavigate();

    const [hoveredButton, setHoveredButton] = useState(null);
    const [showShareModal, setShowShareModal] = useState(false);

    if (!isOpen) return null;

    return createPortal(
        <>
            <div className={shared.modalOverlay}>
                <div className={styles.panelContent}>

                    {/* Title */}
                    <div className={styles.panelTitle} title={tripTitle}>
                        Your trip: <strong>"{tripTitle}"</strong>
                    </div>

                    {/* Button list */}
                    <div className={styles.buttonList}>

                        {/* TODO: Save to list */}
                        {/* <button
                            className={styles.actionButton}
                            // TODO: handleSaveToList
                            onClick={() => { }}
                            onMouseEnter={() => setHoveredButton('save-to-list')}
                            onMouseLeave={() => setHoveredButton(null)}
                        >
                            <div className={styles.iconWrapper}>
                                <img
                                    src={hoveredButton === 'save-to-list' ? save_to_list_clicked : save_to_list_unclicked}
                                    alt="Save to list"
                                    className={styles.saveToListIcon}
                                />
                            </div>
                            <span className={styles.textWrapper}>Save to list</span>
                        </button> */}

                        {/* Share */}
                        <button
                            className={styles.actionButton}
                            onClick={() => setShowShareModal(true)}
                            onMouseEnter={() => setHoveredButton('share')}
                            onMouseLeave={() => setHoveredButton(null)}
                        >
                            <div className={styles.iconWrapper}>
                                <img
                                    src={hoveredButton === 'share' ? share_clicked : share_unclicked}
                                    alt="Share trip"
                                    className={styles.shareIcon}
                                />
                            </div>
                            <span className={styles.textWrapper}>Share</span>
                        </button>

                        {/* TODO: Download trip */}
                        {/* <button
                            className={styles.actionButton}
                            // TODO: handleDownload
                            onClick={() => { }}
                            onMouseEnter={() => setHoveredButton('download')}
                            onMouseLeave={() => setHoveredButton(null)}
                        >
                            <div className={styles.iconWrapper}>
                                <img
                                    src={hoveredButton === 'download' ? download_clicked : download_unclicked}
                                    alt="Download trip"
                                    className={styles.downloadIcon}
                                />
                            </div>
                            <span className={styles.textWrapper}>Download</span>
                        </button> */}

                        {/* Cost analysis */}
                        <button
                            className={styles.actionButton}
                            onClick={() => { navigate(`/cost/${tripId}`) }}
                            onMouseEnter={() => setHoveredButton('cost-analysis')}
                            onMouseLeave={() => setHoveredButton(null)}
                        >
                            <div className={styles.iconWrapper}>
                                <img
                                    src={hoveredButton === 'cost-analysis' ? cost_breakdown_clicked : cost_breakdown_unclicked}
                                    alt="Cost analysis"
                                    className={styles.costIcon}
                                />
                            </div>
                            <span className={styles.textWrapper}>Cost breakdown</span>
                        </button>

                    </div>

                    {/* Cancel / Done */}
                    <div className={styles.panelActions}>
                        <button className={`${styles.actionButton} ${styles.stay}`} onClick={onClose}>
                            <span>Stay</span>
                        </button>
                        <button className={`${styles.actionButton} ${styles.done}`} onClick={onDone}>
                            <span>Go to my trips</span>
                        </button>
                    </div>

                </div>
            </div>

            <ShareModal
                isOpen={showShareModal}
                onClose={() => setShowShareModal(false)}
                tripId={tripId}
                tripTitle={tripTitle}
                access={access}
            />
        </>,
        document.body
    );
};

export default PostSavePanel;